import { FC, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Icon } from "capitalrx-components-2.0/lib/general";
import { Regular } from "capitalrx-components-2.0/lib/typography";
import { Shelf } from "capitalrx-components-2.0/lib/layout";

import { MemberEligibilityContext } from "@/App/context";
import { StorageKeys } from "@/App/constants/constants";

import "./EmulationBanner.scss";

export const EmulationBanner: FC = () => {
  const { t: translate } = useTranslation();
  const { memberEligibility } = useContext(MemberEligibilityContext);

  const parentIdentity = localStorage.getItem(StorageKeys.PARENT_IDENTITY);
  const emulationDate = new Date(localStorage.getItem(StorageKeys.EMULATION_START));

  const memberName = useMemo(() => {
    const firstName = memberEligibility.member.first_name;
    const lastName = memberEligibility.member.last_name;

    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    } else {
      return firstName;
    }
  }, [memberEligibility]);

  const date = useMemo(() => {
    return `${emulationDate.toLocaleDateString([], { month: "short", day: "numeric", year: "numeric" })} ${emulationDate.toLocaleTimeString(
      [],
      {
        hour12: false,
        timeZoneName: "short",
      },
    )}`;
  }, []);

  return (
    <Shelf className="emulation-banner">
      <Shelf.Spacer />
      <Icon name="warning-circle" color="white" />
      <Regular className="emulation-viewing-text">{`${parentIdentity} ${translate("EMULATION_BANNER.viewingMemberPortalAs")} ${memberName} ${translate("EMULATION_BANNER.forAuditingPurposesAt")} ${date}`}</Regular>
      <Shelf.Spacer />
    </Shelf>
  );
};
